// removed by extract-text-webpack-plugin
module.exports = {"comment":"Comment__comment___d0qfK","contact":"Comment__contact___2_uL7","body":"Comment__body___3Sx6q","name":"Comment__name___RY6N7","onlyEmoji":"Comment__onlyEmoji___3BDqo","date":"Comment__date___23o-o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Comment/Comment.scss
// module id = 1170
// module chunks = 1